import clsx from 'clsx'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { MilestoneInfo } from './components/milestone-info'
import styles from './milestone-edit.page.module.scss'
import { RouteEnum } from '../../../constants/routes.enum'
import { useFormBuilderStore } from '../../../entities/form-builder/stores/form-builder.store'
import { MilestoneStatus, MilestoneType } from '../../../entities/workflow/constants/workflow.constants'
import { useGetMilestone, useUpdateMilestone } from '../../../entities/workflow/hooks/workflow.hooks'
import { MilestoneItem } from '../../../entities/workflow/types/workflow.types'
import { FormBuilder, FormBuilderHandle } from '../../shared/form-builder/form-builder'
import { MilestoneEditForm } from '../milestone/types/milestone-types'

export const MilestoneUpdatePage = () => {
  const { t } = useTranslation()
  const builderRef = useRef<FormBuilderHandle>(null)
  const navigate = useNavigate()

  const { id } = useParams()
  const { isLoading, data: milestone } = useGetMilestone(id ? Number(id) : 0)
  const { mutateAsync: updateMilestone } = useUpdateMilestone()
  const clearBuilder = useFormBuilderStore((state) => state.clear)

  useEffect(() => {
    return () => {
      clearBuilder()
    }
  }, [])

  useEffect(() => {
    if (!isLoading && !milestone) {
      toast.error(t('milestone.errors.notFound'))
      navigate(RouteEnum.WORKSPACE + '/' + RouteEnum.MILESTONES)

      return
    }
    if (milestone) {
      console.log(milestone)
    }
  }, [isLoading, milestone])

  const handleMilestoneInfoUpdate = async (values: MilestoneEditForm) => {
    const milestoneInfo: Partial<MilestoneItem> = {
      ...values,
      checkList: builderRef.current?.getForm() ?? [],
      status: MilestoneStatus.New,
      type: MilestoneType.Milestone,
    } as Partial<MilestoneItem>

    try {
      await updateMilestone({
        id: milestone?.id,
        ...milestoneInfo,
      } as MilestoneItem)
      builderRef.current?.clear()
      navigate(RouteEnum.WORKSPACE + '/' + RouteEnum.MILESTONES)
    } catch (error: any) {
      toast.error(error.message)
    }
  }

  return (
    <div className={clsx(styles.milestoneEdit)}>
      <div className="col-3">
        <MilestoneInfo
          milestone={milestone ?? undefined}
          onSave={handleMilestoneInfoUpdate}
        />
      </div>
      <FormBuilder
        ref={builderRef}
        checklist={milestone?.checkList}
        contentWrapClass="col-2"
        previewWrapClass="col-7"
      />
    </div>
  )
}
